import React from 'react';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import MenuItem from '@mui/material/MenuItem';
import Grid from '@mui/material/Grid';
import Link from '@mui/material/Link';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import EmailIcon from '@mui/icons-material/Email';

function Support() {
  const inputStyles = {
    '& .MuiOutlinedInput-root': {
      color: '#E7E8E9',
      '& fieldset': {
        borderColor: '#E7E8E9',
      },
      '&:hover fieldset': {
        borderColor: '#E7E8E9',
      },
      '&.Mui-focused fieldset': {
        borderColor: '#E7E8E9',
      },
    }
  };

  const paperStyles = {
    p: 3, 
    mb: 4, 
    borderColor: '#9F6D47',
    borderWidth: '2px',
    borderStyle: 'solid'
  };

  return (
    <Box>
      <Typography variant="h4" component="h1" gutterBottom>
        Contact & Support
      </Typography>
      
      <Paper elevation={0} sx={paperStyles}>
        <Typography variant="h5" gutterBottom>
          Contact Information
        </Typography>
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
          <EmailIcon sx={{ mr: 1, color: '#9F6D47' }} />
          <Typography>
            Email: <Link href="mailto:support@seekrapp.com" sx={{ color: '#9F6D47' }}>support@seekrapp.com</Link>
          </Typography>
        </Box>
      </Paper>
      
      <Paper elevation={0} sx={paperStyles}>
        <Typography variant="h5" gutterBottom>
          Feedback & Feature Requests
        </Typography>
        <Typography paragraph>
          We value your input! Please share your thoughts or suggestions for improving the app:
        </Typography>
        <Box component="form" noValidate autoComplete="off">
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Name"
                variant="outlined"
                margin="normal"
                InputLabelProps={{
                  style: { color: '#E7E8E9' },
                }}
                sx={inputStyles}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Email"
                variant="outlined"
                margin="normal"
                type="email"
                InputLabelProps={{
                  style: { color: '#E7E8E9' },
                }}
                sx={inputStyles}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                select
                label="Category"
                variant="outlined"
                margin="normal"
                defaultValue="feedback"
                InputLabelProps={{
                  style: { color: '#E7E8E9' },
                }}
                sx={inputStyles}
              >
                <MenuItem value="bug">Report a Bug</MenuItem>
                <MenuItem value="feature">Feature Request</MenuItem>
                <MenuItem value="feedback">General Feedback</MenuItem>
              </TextField>
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Message"
                variant="outlined"
                margin="normal"
                multiline
                rows={4}
                InputLabelProps={{
                  style: { color: '#E7E8E9' },
                }}
                sx={inputStyles}
              />
            </Grid>
            <Grid item xs={12}>
              <Button 
                variant="outlined" 
                sx={{ 
                  color: '#E7E8E9', 
                  borderColor: '#E7E8E9',
                  '&:hover': {
                    borderColor: '#E7E8E9',
                    backgroundColor: 'rgba(231, 232, 233, 0.04)'
                  }
                }}
              >
                Submit
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Paper>
      
      <Paper elevation={0} sx={{ ...paperStyles, mb: 0 }}>
        <Typography variant="h5" gutterBottom>
          Frequently Asked Questions
        </Typography>
        <Accordion sx={{ 
          backgroundColor: 'default', 
          color: '#E7E8E9',
          '&:before': {
            display: 'none',
          },
          borderColor: '#E7E8E9',
          borderWidth: '1px',
          borderStyle: 'solid',
          mb: 1
        }}>
          <AccordionSummary 
            expandIcon={<ExpandMoreIcon sx={{ color: '#E7E8E9' }} />}
            sx={{ borderBottom: '0px' }}
          >
            <Typography>How do I reset my password?</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
              You can reset your password by clicking on the "Forgot Password" link on the login screen and following the instructions sent to your email.
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion sx={{ 
          backgroundColor: 'default', 
          color: '#E7E8E9',
          '&:before': {
            display: 'none',
          },
          borderColor: '#E7E8E9',
          borderWidth: '1px',
          borderStyle: 'solid'
        }}>
          <AccordionSummary 
            expandIcon={<ExpandMoreIcon sx={{ color: '#E7E8E9' }} />}
            sx={{ borderBottom: '0px' }}
          >
            <Typography>Is my data secure?</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
              Yes, we take data security very seriously. All your information is encrypted and stored securely. For more details, please see our Privacy Policy.
            </Typography>
          </AccordionDetails>
        </Accordion>
      </Paper>
    </Box>
  );
}

export default Support;